import { useState } from "react";
import { connect } from "react-redux";
import NavDropDown from "./nav_dropdown";
import { CheckWithPrefixResponse } from "lib/infomation_vender/document";

interface Props {
  information: CheckWithPrefixResponse;
}

function NavBlance(_props: Props) {
  const [showDropDown, setShowDropDown] = useState(false);

  return (
    <div style={{ flexDirection: "row" }}>
      <div>
        <NavDropDown
          information={_props.information}
          showDropDown={showDropDown}
          setShowDropDown={setShowDropDown}
        ></NavDropDown>
      </div>
    </div>
  );
}

const mapStateToProps = (state: any) => {
  return {
    getinfo: state.member.getinfo,
  };
};

export default connect(mapStateToProps)(NavBlance);
